import React, { useState } from "react";
import { Coins, Gift, Ticket, ShoppingBag, ChevronDown, Smartphone, Bell } from "lucide-react";

const STEPS = [
  { k: "punti", icon: Coins, title: "Come guadagni punti", color: "#1E40AF", items: [
    "Mostra la tua card (o il QR dalla sezione \"Il tuo codice cliente\") alla cassa a ogni acquisto.",
    "Il punto vendita registra lo scontrino: i punti vengono accreditati subito e li vedi in Movimenti.",
    "Durante le campagne attive (Iniziative) i punti valgono di più: controlla i moltiplicatori in corso.",
    "Invita un amico con il tuo codice: ricevete entrambi un bonus punti alla sua prima card.",
  ] },
  { k: "premi", icon: Gift, title: "Come riscatti i premi", color: "#059669", items: [
    "Apri Premi: vedi tutti i premi disponibili con i punti richiesti e quelli già raggiunti.",
    "Tocca Prenota: il premio viene messo da parte per te e ricevi una conferma (notifica/WhatsApp).",
    "Quando è pronto ti avvisiamo: passa in negozio, mostra la card e ritiralo. I punti vengono scalati al ritiro.",
  ] },
  { k: "coupon", icon: Ticket, title: "Come usi i coupon", color: "#D97706", items: [
    "In Coupon trovi gli sconti riservati a te (benvenuto, compleanno, promozioni, VIP) con data di scadenza.",
    "Tocca il coupon per aprire il QR e mostralo alla cassa prima di pagare: lo sconto viene applicato subito.",
    "Il giorno prima della scadenza ricevi un promemoria: non lasciare scadere i tuoi vantaggi!",
  ] },
  { k: "ordini", icon: ShoppingBag, title: "Come ordini online", color: "#7C3AED", items: [
    "Apri Ordini → Nuovo ordine: scegli il punto vendita e aggiungi i prodotti dal catalogo (tocca per aggiungere, − / + per la quantità).",
    "Scegli Ritiro in negozio oppure Consegna a domicilio (inserisci l'indirizzo), poi data e ora desiderate.",
    "Invia: segui lo stato (ricevuto → in preparazione → pronto → consegnato) e il tempo stimato. Se disponibile puoi pagare subito con PayPal e ricevi la ricevuta.",
  ] },
  { k: "app", icon: Smartphone, title: "App e notifiche", color: "#0891B2", items: [
    "Aggiungi il portale alla schermata Home del telefono (Condividi → Aggiungi a Home) per usarlo come app.",
    "Attiva le notifiche per ricevere coupon, news, stato ordini e premi pronti in tempo reale.",
    "Carta smarrita? Bloccala subito dal menu: nessuno potrà usare i tuoi punti.",
  ] },
];

export default function HowItWorksPanel({ brand }) {
  const [open, setOpen] = useState("punti");
  return (
    <div className="space-y-3" data-testid="public-howto-panel">
      <div className="rounded-3xl p-5 text-white shadow-md" style={{ background: brand || "#1E40AF" }} data-testid="public-howto-hero">
        <Bell className="h-8 w-8 mb-2 opacity-90" />
        <div className="font-heading font-extrabold text-xl">Come funziona</div>
        <p className="text-sm opacity-90 mt-1">Tutto quello che serve sapere su punti, premi, coupon e ordini in pochi passi.</p>
      </div>
      {STEPS.map((s) => {
        const on = open === s.k;
        return (
          <div key={s.k} className="rounded-2xl bg-white ring-1 ring-zinc-200 overflow-hidden" data-testid={`public-howto-${s.k}`}>
            <button type="button" onClick={() => setOpen(on ? null : s.k)} className="w-full flex items-center gap-3 p-4 text-left" data-testid={`public-howto-toggle-${s.k}`}>
              <span className="h-10 w-10 rounded-xl flex items-center justify-center text-white shrink-0" style={{ background: s.color }}><s.icon className="h-5 w-5" /></span>
              <span className="flex-1 font-heading font-bold text-zinc-900">{s.title}</span>
              <ChevronDown className={`h-4 w-4 text-zinc-400 transition-transform ${on ? "rotate-180" : ""}`} />
            </button>
            {on && (
              <ol className="px-4 pb-4 space-y-2" data-testid={`public-howto-steps-${s.k}`}>
                {s.items.map((t, i) => (
                  <li key={i} className="flex gap-3 text-sm text-zinc-700">
                    <span className="h-6 w-6 rounded-full text-[11px] font-bold flex items-center justify-center shrink-0" style={{ background: `${s.color}1a`, color: s.color }}>{i + 1}</span>
                    <span className="leading-relaxed">{t}</span>
                  </li>
                ))}
              </ol>
            )}
          </div>
        );
      })}
    </div>
  );
}
